/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CaseSanctionType {
  NO_ACTION = 'no_action',
  WARNING = 'warning',
  REVOCATION = 'revocation',
  SUSPENSION = 'suspension',
  RESTRICTIONS = 'restrictions',
  OTHER = 'other',
  ADMINISTRATIVE_PENALTY = 'administrative_penalty',
  PENALTY_AND_REVOCATION = 'penalty_and_revocation',
}
